import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Panel, PanelHeaderTemplateOptions } from "primereact/panel";
import NadaConsta from "../../../../components/nadaConsta";
import { useTranslation } from "react-i18next";
import { formatarParaMoedaBRL } from "../../../../utils";

export const Gps895Page = (data: any) => {
  const PENDENCIAS_F = data?.PEND_FINANCEIRAS;
 
  const { t } = useTranslation();
  const headerTemplate = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {PENDENCIAS_F?.OCORRENCIAS && PENDENCIAS_F?.OCORRENCIAS.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoMercado')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('restricaoMercado')}</span>) }</div>;
  }

  const headerTemplateProtesto = (options: PanelHeaderTemplateOptions) => {
    const className = `${options.className} `;
    return  <div className={className}> {data.PROTESTOS.OCORRENCIAS  && data.PROTESTOS.OCORRENCIAS.length > 0 ? (<div><span style={{color:'#C70039'}} className="pi-consulta pi pi-exclamation-triangle"></span><span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span></div>) : (<span className="p-panel-title" style={{marginLeft:'1rem', fontFamily: 'var(--font-family)', color:'black'}}>{t('protestos')}</span>) }</div>;
  }

  const getValue = (value: string) => value || "Não informado";


  return (
    <div>
      
      <Panel headerTemplate={headerTemplateProtesto} toggleable>
        {!data.PROTESTOS.OCORRENCIAS || data?.PROTESTOS?.OCORRENCIAS.length === 0 ? (<NadaConsta></NadaConsta>) : (
        <DataTable
          value={data?.PROTESTOS?.OCORRENCIAS}
          emptyMessage="Nada consta"
        >
          <Column
            header="Comarca"
            body={(data: any) => getValue(data?.ORIGEM)}
          />
          <Column
            header="Cartório"
            body={(data: any) => getValue(data?.CARTORIO)}
          />
          <Column
            header="Valor"
            body={(data: any) => formatarParaMoedaBRL(Number(data?.VALOR.replace(',','.')))}
          />
          <Column header="Data" body={(data: any) => getValue(data?.DATA)} />
          <Column
            header="Vencimento"
            body={(data: any) => getValue(data?.VENCIMENTO)}
          />
        </DataTable>)}
      </Panel>

      <br />
      <br />

      <Panel headerTemplate={headerTemplate}  toggleable>
        {!PENDENCIAS_F.OCORRENCIAS || PENDENCIAS_F?.OCORRENCIAS.length == 0 ? (<NadaConsta></NadaConsta>) :(
        <DataTable
          value={PENDENCIAS_F?.OCORRENCIAS}
        >
          <Column header="Modalidade" field="MODALIDADE" />
          <Column header="Contrato" field="CONTRATO" />
          <Column header="Tipo de Devedor" field="TIPO_DEVEDOR" />
          <Column header="Credor" field="CREDOR" />
          <Column header="Valor" field="VALOR" />
          <Column header="Data de Vencimento" field="DATA_VENCIMENTO" />
          <Column header="Data de Inclusão" field="DATA_INCLUSAO" />
          <Column header="Origem" field="ORIGEM" />
        </DataTable>)}
      </Panel>
      <br />
      <br />
      
    </div>
  );
};
